<header
  id="header-section"
  class="w-100 border bg-white py-3 py-lg-5 d-flex justify-content-center align-items-center position-relative"
>
  <div class="w-80 d-flex justify-content-between align-items-center">
    <img
      class="perval-logo d-none d-lg-block"
      src="assets/images/logo_perval_landing_page.svg"
      alt="logo perval"
    />
    <img
      class="perval-logo d-lg-none"
      src="assets/perval-icons/logo_perval_mini.svg"
      alt="logo perval"
    />
    <div class="d-none d-lg-flex flex-column gap-3 align-items-end">
      <div class="d-flex gap-3 justify-content-end align-items-center">
        <p class="m-0 fw-medium fs-4-text">Nous contacter</p>

        <a id="btn_landing_tel" href="tel:0800710620">
          <img
            class="tel-picture"
            src="assets/images/hotline_num.png"
            alt="téléphone : 0 800 710 620"
          />
        </a>
      </div>
      <div class="d-flex align-items-center gap-3">
        <a
          *appFeatureFlag="FeaturesEnum.INSCRIPTION_AUTONOME"
          [routerLink]="['/inscription']"
          id="btn_landing_inscription"
          class="btn btn-lg rounded-bottom-start-50 rounded-top-end-50 rounded-top-start-0 rounded-bottom-end-0 px-4 py-2 text-white btn-primary-landing border black-background"
          >Créer mon compte
          <img class="px-1" src="assets/perval-icons/arrow-right-circle.svg"
        /></a>
        <a
          [routerLink]="['/connexion']"
          id="btn_landing_connexion"
          class="btn btn-lg rounded-bottom-start-50 rounded-top-end-50 rounded-top-start-0 rounded-bottom-end-0 px-4 py-2 text-white btn-primary-landing border green-primary-background"
          >Connexion client
          <img class="px-1" src="assets/perval-icons/arrow-right-circle.svg"
        /></a>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-center gap-3 d-lg-none"
    >
      <a href="tel:0800710620">
        <img src="assets/perval-icons/telephone-fill.svg" alt="appeler" />
      </a>
      <img
        (click)="onBurgerClick()"
        src="assets/perval-icons/list.svg"
        alt="menu"
      />
    </div>
  </div>
  <app-burger-menu
    (menuCanceled)="onBurgerClick()"
    [isActive]="isActive"
  ></app-burger-menu>
</header>
